import { render } from "./select.html?vue&type=template&id=ba4f0ce6&ts=true&external"
import script from "./select.ts?vue&type=script&lang=ts&external"
export * from "./select.ts?vue&type=script&lang=ts&external"

import "./select.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__